import React from 'react'
import DiscretionaryRenewalRequest from '../../../features/gmap/DiscretionaryRenewalRequest/DiscretionaryRenewalRequest'

const gmapDiscretionaryRenewalRequest = () => {
    return (
        <DiscretionaryRenewalRequest />
    )
}

export default gmapDiscretionaryRenewalRequest